import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import OrderCreatedSummaryModal from '../components/OrderCreatedSummaryModal';

const OrderCreatedSummaryPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [loadedOrder, setLoadedOrder] = useState(null);
  const searchParams = new URLSearchParams(location.search);
  const orderNumber = searchParams.get('order_number') || '';

  useEffect(() => {
    const title = `Сводка заказа №${loadedOrder?.order_number || orderNumber || id || '—'}`;
    window.dispatchEvent(new CustomEvent('orderheadertitle', {
      detail: {
        title,
        urgent: false,
        clientVip: false,
        dispatcherPriority: false,
        dispatcherCallRequiredStage: null
      }
    }));

    return () => {
      window.dispatchEvent(new CustomEvent('orderheadertitle', {
        detail: {
          title: '',
          urgent: false,
          clientVip: false,
          dispatcherPriority: false,
          dispatcherCallRequiredStage: null
        }
      }));
    };
  }, [id, loadedOrder, orderNumber]);

  const handleBack = () => {
    if (typeof window !== 'undefined' && window.history.length > 1) {
      navigate(-1);
      return;
    }

    navigate('/new-order', {
      replace: true,
      state: {
        rootEntry: true,
        rootSection: '/new-order'
      }
    });
  };

  return (
    <OrderCreatedSummaryModal
      open
      orderId={id}
      orderNumber={orderNumber}
      onClose={handleBack}
      variant="page"
      backAriaLabel="Вернуться назад"
      onOrderLoaded={setLoadedOrder}
    />
  );
};

export default OrderCreatedSummaryPage;
